import { render } from "./SurveyInputMultiSelect.vue?vue&type=template&id=05652d7c&ts=true"
import script from "./SurveyInputMultiSelect.vue?vue&type=script&lang=ts"
export * from "./SurveyInputMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__